<!-- eslint-disable -->
<template>
  <div class="row">
    <div class="col-md-12">
      <div class="mt-2 mb-4 ">

        <div class="noble-ui-logo d-block mb-2"> Chiffre d'affaires total pour tous <span>&nbsp;les
            restaurants</span></div>
      </div>
    </div>
  </div>
  <div class="card mb-3">
     <SectionLoaderView v-if="loadingRequest?.BoardStatAllSites" />
    <div class="card-body">
      <div v-if="listChiffreAffaires?.length > 0" class="row">
        <div class="col-md-12 type_ca grid-8 mb-3">
          <span type="button" class="btn btn-info btn-icon-text  " @click="filterData('today', true)"
            :class="{ 'selected-default-dates': datePicker.defaultDates.type == 'today' }">

            {{ $t(`content.button.today`) }}
            <p class="chiffre-afaire">
              {{
                listChiffreAffaires[0][0]
                  ? listChiffreAffaires[0][0]["Chiffre d'affaires (CA)"].toFixed(2)
                  : "0.00"
              }}
              €</p>
          </span>

          <span type="button" class="btn btn-info btn-icon-text  " @click="filterData('yesterday', true)"
            :class="{ 'selected-default-dates': datePicker.defaultDates.type == 'yesterday' }">

            {{ $t(`content.button.yesterday`) }}
            <p class="chiffre-afaire">
              {{
                listChiffreAffaires[1][0]
                  ? listChiffreAffaires[1][0]["Chiffre d'affaires (CA)"].toFixed(2)
                  : "0.00"
              }}
              €</p>
          </span>

          <span type="button" class="btn btn-info btn-icon-text  " @click="filterData('week', true)"
            :class="{ 'selected-default-dates': datePicker.defaultDates.type == 'week' }">

            {{ $t(`content.button.week`) }}
            <p class="chiffre-afaire">
              {{
                listChiffreAffaires[2][0]
                  ? listChiffreAffaires[2][0]["Chiffre d'affaires (CA)"].toFixed(2)
                  : "0.00"
              }}
              €</p>
          </span>

          <span type="button" class="btn btn-info btn-icon-text  " @click="filterData('previous_week', true)"
            :class="{ 'selected-default-dates': datePicker.defaultDates.type == 'previous_week' }">

            {{ $t(`content.button.previous_week`) }}
            <p class="chiffre-afaire">
              {{
                listChiffreAffaires[3][0]
                  ? listChiffreAffaires[3][0]["Chiffre d'affaires (CA)"].toFixed(2)
                  : "0.00"
              }} €</p>
          </span>

          <span type="button" class="btn btn-info btn-icon-text  " @click="filterData('month', true)"
            :class="{ 'selected-default-dates': datePicker.defaultDates.type == 'month' }">

            {{ $t(`content.button.month`) }}
            <p class="chiffre-afaire">
              {{
                listChiffreAffaires[4][0]
                  ? listChiffreAffaires[4][0]["Chiffre d'affaires (CA)"].toFixed(2)
                  : "0.00"
              }}
              €</p>
          </span>
          <span type="button" class="btn btn-info btn-icon-text  " @click="filterData('previous_month', true)"
            :class="{ 'selected-default-dates': datePicker.defaultDates.type == 'previous_month' }">

            {{ $t(`content.button.previous_month`) }}
            <p class="chiffre-afaire"> {{
              listChiffreAffaires[5][0]
                ? listChiffreAffaires[5][0]["Chiffre d'affaires (CA)"].toFixed(2)
                : "0.00"
            }} €</p>
          </span>
          <span type="button" class="btn btn-info btn-icon-text  " @click="filterData('year', true)"
            :class="{ 'selected-default-dates': datePicker.defaultDates.type == 'year' }">

            {{ $t(`content.button.year`) }}
            <p class="chiffre-afaire">
              {{
                listChiffreAffaires[6][0]
                  ? listChiffreAffaires[6][0]["Chiffre d'affaires (CA)"].toFixed(2)
                  : "0.00"
              }} €</p>
          </span>
          <span type="button" class="btn btn-info btn-icon-text  " @click="filterData('previous_year', true)"
            :class="{ 'selected-default-dates': datePicker.defaultDates.type == 'previous_year' }">

            {{ $t(`content.button.previous_year`) }}
            <p class="chiffre-afaire">
              {{
                listChiffreAffaires[7][0]
                  ? listChiffreAffaires[7][0]["Chiffre d'affaires (CA)"].toFixed(2)
                  : "0.00"
              }} €</p>
          </span>

        </div>
        <div class="col-md-12 mb-3 d-flex">
          <div class="w-50 p-1">
            <label for="Date" class="form-label">Dates</label>
            <VueDatePicker locale="fr" @update:model-value="handleDate" v-model="selectedDates"
              :action-row="{ showSelect: false, showCancel: false }" range multiCalendars :enableTimePicker="true"
              format="dd-MM-yyyy HH:mm" close-on-scroll auto-apply show-now-button />
          </div>
          <div v-if="$route.name === 'dashboard'" class="w-50 p-1">
            <label for="date-1" class="form-label">Date N-1</label>
            <VueDatePicker locale="fr" v-model="selectedDatesN1" disabled
              :action-row="{ showSelect: false, showCancel: false }" range multiCalendars :enableTimePicker="true"
              format="dd-MM-yyyy HH:mm" close-on-scroll auto-apply show-now-button />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <SectionLoaderView v-if="loadingRequest?.BoardStatAllSites" />
    <div class="col-md-12">
      <div class="mt-2 mb-4 ">

        <div class="noble-ui-logo d-block mb-2"> Chiffre d'affaires total par <span>&nbsp;restaurant</span></div>
      </div>
    </div>
  </div>
  <div v-if="dashboard?.stat_principal?.data" class="row mb-3">
    <div v-for="(stats, index) in dashboard?.stat_principal?.data"
      class="col-xl-6 col-lg-6 mb-3 d-flex align-items-stretch card-100">
      <div class="card card-stats mb-4 mb-xl-0">
        <div class="card-body">
          <div
            class="statistique statistique-font-size font-weight-bold mb-0 d-flex height-100 sjustify-content-center align-items-center">
            <div class="w-100">
              <div class="text-centers text-uppercase font-size-20">
                <div>

                  {{ $t("content.pages.dashboard.cards.couvert_n.couvert") }} :
                  <span class="float-end">
                    {{
                      stats?.entete
                        ? stats?.entete?.totalCouvertTable
                        : "0"
                    }}
                  </span>
                </div>
              </div>
              <div class="text-centers text-uppercase font-size-20 mt-2">
                <div>

                  {{ $t("content.pages.dashboard.cards.couvert_n.couvert_moyen") }}:
                  <span class="float-end">
                    {{
                      stats?.entete
                        ? stats?.entete?.totalCouvertMoyenneTable?.toFixed(2)
                        : "0.00"
                    }}
                    €
                  </span>
                </div>
              </div>
              <div class="text-centers text-uppercase font-size-20 mt-2">
                <div>

                  {{ $t("content.pages.dashboard.cards.couvert_n.ca_table") }} :
                  <span class="float-end">
                    {{
                      stats?.entete
                        ? stats?.entete?.totalChiffreCATable.toFixed(
                          2
                        )
                        : "0.00"
                    }}
                    €
                  </span>
                </div>
              </div>
              <div class="text-centers text-uppercase font-size-20 mt-2">
                <div>

                  {{ $t("content.pages.dashboard.cards.couvert_n.ca") }} :
                  <span class="float-end">
                    {{
                      stats?.entete
                        ? stats?.entete?.totalChiffreCA.toFixed(
                          2
                        )
                        : "0.00"
                    }}
                    €
                  </span>
                </div>
              </div>
              <div class="text-centers text-uppercase font-size-20 mt-2">
                <div>

                  {{ $t("content.pages.dashboard.cards.couvert_n.reglements") }} :
                  <span class="float-end">
                    {{
                      stats?.reglements
                        ? stats?.reglements?.TotalValeur.toFixed(2)
                        : "0.00"
                    }}
                    €
                  </span>
                </div>
              </div>
              <div class="text-center text-uppercase hr-border">
                <h3 v-if="stats?.site">
                  {{ stats?.site?.LibSite }}
                </h3>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<!-- eslint-disable -->
<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import LineChart from "@/components/chartVue/ChartLine.vue";
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";

import { DateTime } from "luxon";
import { isMoreThan24HoursFake } from '@/Utils/useDateDiff'


export default {
  components: { LineChart, VueDatePicker },
  name: "mongoDATA",
  watch: {
    "datePicker.date.range"(newDate, oldDate) {
      if (newDate !== oldDate && newDate?.length > 0)
        this.callFunctions(
          this.datePicker.date.from,
          this.datePicker.date.to,
          this.datePicker.defaultDates.type
        );
    },
  },
  data() {
    return {
      all_sites: [],
      selectedDates: [],
       dashboard: {
         stat_principal: [],  
      },  
    };
  },
  async mounted() {
    if (this.isAuthenticated && this.isRole == 'manager') {
      if (this.all_sites?.length > 0) {
        if (this.datePicker.date.range?.length > 0) {
          this.selectedDates = this.datePicker.date.range
        }

        this.getChffireAffaires();


        this.callFunctions(
          this.datePicker.date.from,
          this.datePicker.date.to,
          this.datePicker.defaultDates.type
        );
      }
    }
  },
  async created() {
    this.all_sites = this.$store.state.managerWithStores?.associatedRestaurants.map(site => site._id)

  },
  unmounted() {
  },
  methods: {
    ...mapMutations(["setTicketID", "InitListChiffreAffaires"]),
     ...mapActions([
      "BoardStatAllSites",
      "chiffreAffaires"
    ]),


    async callFunctions(from, to, type) {
      if (this.currentSite?._id) {
        const ok = await isMoreThan24HoursFake(this.datePicker.date.range)
        if (ok) {
          // ✅ Safe to continue search
          let range = from
          this.getStatPrincipal(range, to);
        }   
      
      }
    },




    async getStatPrincipal(from, to) {
      
      this.dashboard.stat_principal = []
      let qte = "qte";
      let page = 1;
      let limit = 0;
      let self = this;
      this.dashboard.stat_principal = await this.BoardStatAllSites({
        url: "board/stat-all-sites",
        page: page,
        limit: limit,
        range: self.datePicker.date.range,
        vendeur: "vendeur",
        site: self.all_sites,
        qte: qte,
        WhereLibInArray: [
          { LibValeur: 'vendeur', LibKey: 'LibVendeur' },
          { LibValeur: 'caisse', LibKey: 'LibCaisse' },
          { LibValeur: ['VENTE', 'TRANSFERT', 'ANNULATION'], LibKey: 'Operation' },
        ]
      });
    },


    filterData(option, selectOption) {

      const timeZone = 'Europe/Paris';
      const currentDate = DateTime.now().setZone(timeZone);

      const [fromHour = '00', fromMinutes = '00'] = this.parametrages?.calculeTicket?.TimeDebut?.split(':') || [];
      const [toHour = '23', toMinute = '59'] = this.parametrages?.calculeTicket?.TimeFin?.split(':') || [];

      const startTime = { hour: fromHour, minute: fromMinutes };
      const endTime = { hour: toHour, minute: toMinute };

      let dateFrom, dateTo;

      const applyOffset = (baseDate, amount) => baseDate.minus(amount);
      const withStart = (date) => date.set(startTime);
      const withEnd = (date) => date.set(endTime);

      switch (option) {
        case 'today':
          dateFrom = withStart(currentDate);
          dateTo = withEnd(dateFrom);
          break;

        case 'yesterday':
          dateFrom = withStart(currentDate.minus({ day: 1 }));
          dateTo = withEnd(dateFrom);
          break;

        case 'week':
          dateFrom = withStart(currentDate.startOf('week'));
          dateTo = withStart(currentDate.endOf('week').minus({ days: 1 }));
          break;

        case 'previous_week':
          dateFrom = withStart(currentDate.startOf('week').minus({ weeks: 1 }));
          dateTo = withEnd(currentDate.endOf('week').minus({ weeks: 1, days: 1 }));
          break;

        case 'month':
          dateFrom = withStart(currentDate.startOf('month'));
          dateTo = withEnd(currentDate.endOf('month'));
          break;

        case 'previous_month':
          dateFrom = withStart(currentDate.startOf('month').minus({ months: 1 }));
          dateTo = withEnd(currentDate.endOf('month').minus({ months: 1 }));
          break;

        case 'year':
          dateFrom = withStart(currentDate.startOf('year'));
          dateTo = withEnd(currentDate.endOf('year'));
          break;

        case 'previous_year':
          dateFrom = withStart(currentDate.startOf('year').minus({ years: 1 }));
          dateTo = withEnd(currentDate.endOf('year').minus({ years: 1 }));
          break;
      }

      // N-1 year calculation
      let dateNFrom = dateFrom.minus({ years: 1 });
      let dateNTo = dateTo.minus({ years: 1 });

      // Extend range if time start is not midnight
      if (+fromHour > 0) {
        dateTo = dateTo.plus({ days: 1 });
        dateNTo = dateNTo.plus({ days: 1 });
      }

      const formatISO = (d) => d.toISO({ includeOffset: false, suppressMilliseconds: false });
      const formatDisplay = (d) => d.toFormat('MM-dd-yyyy HH:mm');

      const formattedDateFrom = formatISO(dateFrom);
      const formattedDateTo = formatISO(dateTo);
      const formattedNDateFrom = formatISO(dateNFrom);
      const formattedNDateTo = formatISO(dateNTo);

      if (selectOption) {
        this.datePicker.date = {
          from: formatDisplay(dateFrom),
          to: formatDisplay(dateTo),
          range: [formattedDateFrom, formattedDateTo],
        };

        this.datePicker.date_n = {
          from: formatDisplay(dateNFrom),
          to: formatDisplay(dateNTo),
          range: [formattedNDateFrom, formattedNDateTo],
        };

        this.selectedDates = [this.datePicker.date.from, this.datePicker.date.to];
        this.selectedDatesN1 = [this.datePicker.date_n.from, this.datePicker.date_n.to];
        this.datePicker.defaultDates.type = option;
      }

      if (!selectOption) {
        return [formattedDateFrom, formattedDateTo];
      }
    },
    handleDate(selectedDate) {
      if (!selectedDate || selectedDate.length < 2) return;

      const [fromHour = '00', fromMinutes = '00'] = this.parametrages?.calculeTicket?.TimeDebut?.split(':') || [];
      const [toHour = '23', toMinute = '59'] = this.parametrages?.calculeTicket?.TimeFin?.split(':') || [];

      const dateFrom = DateTime.fromFormat(this.$dayjs(selectedDate[0]).format('YYYY-MM-DD HH:mm'), 'yyyy-MM-dd HH:mm');
      let dateTo = DateTime.fromFormat(this.$dayjs(selectedDate[1]).format('YYYY-MM-DD HH:mm'), 'yyyy-MM-dd HH:mm');

      let dateNFrom = dateFrom.minus({ year: 1 });
      let dateNTo = dateTo.minus({ year: 1 });

      if (+fromHour > 0) {
        dateTo = dateTo.plus({ day: 1 });
        dateNTo = dateNTo.plus({ day: 1 });
      }

      this.datePicker.date = {
        from: dateFrom.toFormat('MM-dd-yyyy HH:mm'),
        to: dateTo.toFormat('MM-dd-yyyy HH:mm'),
        range: [
          dateFrom.toISO({ includeOffset: false, suppressMilliseconds: false }),
          dateTo.toISO({ includeOffset: false, suppressMilliseconds: false }),
        ],
      };

      this.datePicker.date_n = {
        from: dateNFrom.toFormat('MM-dd-yyyy HH:mm'),
        to: dateNTo.toFormat('MM-dd-yyyy HH:mm'),
        range: [
          dateNFrom.toISO({ includeOffset: false, suppressMilliseconds: false }),
          dateNTo.toISO({ includeOffset: false, suppressMilliseconds: false }),
        ],
      };

      this.datePicker.defaultDates.type = null;
      this.selectedDatesN1 = [this.datePicker.date_n.from, this.datePicker.date_n.to];
    },
    async getChffireAffaires() {
       this.InitListChiffreAffaires();
      const dates = ['today', 'yesterday', 'week', 'previous_week', 'month', 'previous_month', 'year', 'previous_year']
      let self = this
      this.datePicker.defaultDates.list = []
      dates.forEach((element) => {

        this.datePicker.defaultDates.list.push(self.filterData(element, false))
      });
      this.chiffre_affaires = [];
      this.chiffre_affaires = await this.chiffreAffaires({
        url: "entetes/chiffre-affaire",
        vendeur: "vendeur",
        site: self.all_sites,
        rangeDates: this.datePicker.defaultDates.list
      });
    },
  },
  computed: {
    ...mapGetters({
      isAuthenticated: "isAuthenticated",
      isRole: "isRole",
      res: "StateRes",
      currentSite: "currentSite",
      listChiffreAffaires: "listChiffreAffaires",
      TimeDebutCalclule: "TimeDebutCalclule"
    }),
    ...mapState(["ticket_id", "datePicker", 'chiffre_affaires', "loadingRequest"]),
    // return this.$store.state.user;
    chiffredaffaires() {
      if (this.chiffre_affaires.length > 0) {
        return this.chiffre_affaires;
      }
      return [];
    },

  },
};
</script>
<!-- eslint-disable -->

<style>
.selected-default-dates {
  background: #084593 !important;
  color: #fff !important;
}

.card-100 .card {
  width: 100%;
}

.card .card-title {
  margin-bottom: 0px !important;
}



.type_ca span.brut {
  border-left: 1px solid #d9d9d9;
  border-right: 0px solid #d9d9d9;
  border-radius: 2px 0 0 2px;
}

.type_ca span.net {
  border-left: 0px solid #d9d9d9;
  border-right: 1px solid #d9d9d9;
  border-radius: 0 2px 2px 0;
}

.btn-event-export {
  border: 1px solid #bdbdbd;
  padding: 5px;
  text-align: center;
  background: #fff;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

.statistique-font-size {
  font-size: 20px;
}

.statistique {
  font-weight: 600;
  margin-top: 10px !important;
  display: block;
  margin: 0px !important;
}

.height-100 {
  height: 100%;
}

.geolocation.latlong {
  font-size: 15px;
}

.font-size-20 {
  font-size: 14px;
}

.card-body {
  padding: 0.8rem 0.8rem !important;
}


.percentage svg {
  margin-right: 4px;
}

.percentage .red {
  color: red !important;
}

.percentage .green,
.percentage {
  color: #14e114;
}

.percentage {
  width: 90px;
  display: inline-block;
}
</style>
